/**
 * @description
 *
 * Перенаправляет по указанному URL
 *
 * @param {string} url - путь для редиректа
 */
function setLocation(url) {
  window.location.href = url
}

export default setLocation
